import { initClient } from "rwsdk/client";
import "./app/globals.css";

initClient();
